<template>
	<div>
		<div
		class="home"
		v-scroll-spy="{ offset: 130 }"
		>
		<!-- :style="{ marginTop: `${$store.getters['dom/topMenuOffset']}px` }" -->

		<!-- <LandingVideo/> -->
		<Hero />
		<!-- <MeetAndGreet @modalShow="modalShow"/> -->
		<Benefits />
		<CustomizeEvents />
		<CustomizeTwoGifts />
		<SeatingPricing />
		<Faq />
		<ContactUs @modalShow="modalShow"/>

	</div>
	<AppHeader @modalShow="modalShow"></AppHeader>
	<!-- @modalShow="modalShow" -->
	<joinUs
	 :success="success"
	 :modalActive="modalActive"
	 @modalHide="modalHide"
   />
	<!-- <AppFooter></AppFooter> -->

	<!-- <SelectSize :modalActive="modalActive" @modalHide="modalHide" /> -->
	<!-- <CustomizeBrick :brickActive="brickActive" @brickHide="brickHide" /> -->
	<!-- <Optout :OptoutActive="OptoutActive" @optOutHide="optOutHide" /> -->
	<!-- <upgradeSeats :upgradeActive="upgradeActive" @upgradeHide="upgradeHide" /> -->


</div>
</template>
<script>
import AppHeader from "@/layout/Header.vue";
// import AppFooter from "@/layout/Footer.vue";
import Hero from "./Hero";
// import MeetAndGreet from "./BrickSection";
import CustomizeEvents from "./CustomizeEvents";
import CustomizeTwoGifts from "./CustomizeTwoGifts";
import Benefits from "./Benefits";
import SeatingPricing from "./SeatingPricing";
import Faq from "./Faq";
import ContactUs from "./ContactUs";
// import LandingVideo from "./LandingVideo";
// import Optout from "./MeetAndGreet/Optout";
import joinUs from "@/pages/Home/Hero/joinUs";
export default {

	components: {
		AppHeader,
		// LandingVideo,
		Hero,
		// MeetAndGreet,
		Benefits,
		CustomizeEvents,
		CustomizeTwoGifts,
		SeatingPricing,
		Faq,
		ContactUs,
		joinUs,
	},

	data() {
		return {
			 modalActive: false,
			// OptoutActive: false,
			showVideo : true,
		};
	},

	// methods: {
	//
	// 	skipVideo() {
	// 		this.showVideo = false;
	// 	},
	// 	optOutHide(){
	// 		this.OptoutActive  = false;
	// 	},
	// 	optOutShow(){
	// 		this.OptoutActive  = true;
	// 	},
	// },
	mounted() {
	   this.modalShow();
	},
  methods: {
    modalShow() {
      this.modalActive = true;
    },
    modalHide() {
      this.modalActive = false;
    },
  },


};
</script>

<style lang="scss" scoped>


</style>
